/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteTriggerInstanceSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteTriggerInstanceRequest = {
  /**
   * The trigger instance ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteTriggerInstanceSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteTriggerInstanceSecurity$outboundSchema: z.ZodMiniType<
  DeleteTriggerInstanceSecurity$Outbound,
  DeleteTriggerInstanceSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteTriggerInstanceSecurityToJSON(
  deleteTriggerInstanceSecurity: DeleteTriggerInstanceSecurity,
): string {
  return JSON.stringify(
    DeleteTriggerInstanceSecurity$outboundSchema.parse(
      deleteTriggerInstanceSecurity,
    ),
  );
}

/** @internal */
export type DeleteTriggerInstanceRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteTriggerInstanceRequest$outboundSchema: z.ZodMiniType<
  DeleteTriggerInstanceRequest$Outbound,
  DeleteTriggerInstanceRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteTriggerInstanceRequestToJSON(
  deleteTriggerInstanceRequest: DeleteTriggerInstanceRequest,
): string {
  return JSON.stringify(
    DeleteTriggerInstanceRequest$outboundSchema.parse(
      deleteTriggerInstanceRequest,
    ),
  );
}
